import { isNil } from 'ramda';

export const isEvenNumber = (value: number): boolean => (isNil(value) ? false : value % 2 === 0);
